import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import ActiveChip from 'components/Common/ActiveChip';
import getCertifictionStatus from 'common/Forms/CertificationStatus';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';
import LoadingWrapper from 'components/Common/LoadingWrapper';
import moment from 'moment';

const AccountControllingPersonsList = ({ isGettingControllingPersons, controllingPersons, forms, onConfirmCpUnlink, onConfirmCpRemove, accountIsActive }) => {
  const [displayAll, setDisplayAll] = useState(null);

  const handleDisplayAll = () => {
    setDisplayAll(!displayAll);
  };

  const IsFatcaCrs = (entityFormId) => {
    const entityForm = forms.find(({ id }) => id === entityFormId);
    return entityForm && entityForm.formType.toLowerCase().indexOf('fatca_crse') >= 0;
  };

  let cpsToDisplay;

  if (controllingPersons) {
    if (!displayAll) {
      cpsToDisplay = controllingPersons.filter(cp => cp.effectiveTo === null);
    } else {
      cpsToDisplay = controllingPersons;
    }
  }

  return (<div>
    { isGettingControllingPersons && <LoadingWrapper loaded={ !isGettingControllingPersons } />}
    <label className="form-checkbox option mb-10">
      <input
        type="checkbox"
        name="displayAllCpsStatus"
        checked={ displayAll }
        onClick={ handleDisplayAll }
        id="cp-display-all-checkbox"
      />
      <i className="form-icon" /><span className="option-label" id="cp-display-all-checkbox-text"> Display All Controlling Persons</span>
    </label>
    <div>
      <table className="table table-striped table-hover table-bordered" id="cp-table">
        <thead>
          <tr>
            <th>Controlling Person Status</th>
            <th>Effective From</th>
            <th>Effective To</th>
            <th>Entity Form (Signed)</th>
            <th>Customer Id</th>
            <th>Customer Status</th>
            <th>Name</th>
            <th>Type</th>
            <th>Address</th>
            <th>Date Of Birth</th>
            <th>Certification Status</th>
            <th>Source (Signed)</th>
            <AccessControl allowedPermissions={ [ActivityPerms.accountEdit] }>
              <th>Unlink</th>
            </AccessControl>
          </tr>
        </thead>
        <tbody>
          { cpsToDisplay && cpsToDisplay.length > 0 && cpsToDisplay.map(cp => (
            <tr key={ cp.id }>
              {(() => {
                const today = moment();
                const effectiveTo = cp.effectiveTo ? moment(cp.effectiveTo) : null;
                const effectiveFrom = moment(cp.effectiveFrom);

                const isActive = effectiveFrom && today.isSameOrAfter(effectiveFrom, 'day') && (!effectiveTo || today.isBefore(effectiveTo, 'day'));

                return (
                  <React.Fragment>
                    <td align="center" id="cp-controlling-person-status"><ActiveChip isActive={ isActive } /></td>
                    <td align="center" id="cp-effective-from-date">{ effectiveFrom.format('MMM DD, YYYY') }</td>
                    <td align="center" id="cp-effective-to-date">{ effectiveTo && effectiveTo?.format('MMM DD, YYYY') }</td>
                  </React.Fragment>
                );
              })()}
              {
                forms && forms.length > 0 && <td align="center" id="cp-entity-form">{(
                  () => {
                    const accountForm = forms.find(({ id }) => id === cp.entityFormId);
                    if (accountForm) {
                      return `${ accountForm.formTypeDescription } (${ accountForm.dateSigned !== null ? moment(accountForm.dateSigned).format('MMM DD, YYYY') : '' })`;
                    }
                    return 'N/A - form not found';
                  }
                )()}
                </td>
              }
              <td align="center" id="cp-customer-id"><Link to={ `/customer/${ cp.cpCustomerDbId !== null ? cp.cpCustomerDbId : cp.entityCustomerDbId }` }>{ cp.cpCustomerId }</Link></td>
              <td align="center" id="cp-customer-status"><ActiveChip isActive={ cp.isCpCustomerActive } /></td>
              <td align="center" id="cp-name">{ cp.name }</td>
              <td align="center" id="cp-type">{ cp.data?.type ? cp.data.type : cp.cpType }</td>
              <td align="center" id="cp-address">{
                  cp.data && cp.data.address
                  && <React.Fragment>
                    <span>{cp.data.address.line1 !== null ? `${ cp.data.address.line1 } ` : ''}</span>
                    <span>{cp.data.address.line2 !== null ? `${ cp.data.address.line2 } ` : ''}</span>
                    <span>{cp.data.address.line3 !== null ? `${ cp.data.address.line3 } ` : ''}</span>
                    <span>{cp.data.address.line4 !== null ? `${ cp.data.address.line4 } ` : ''}</span>
                    <span>{cp.data.address.postalCode !== null ? `${ cp.data.address.postalCode } ` : ''}</span>
                    <span>{cp.data.address.country !== null ? `${ cp.data.address.country } ` : ''}</span>
                  </React.Fragment>
                  }
              </td>
              <td align="center" id="cp-dob">{ cp.data && cp.data.dateOfBirth ? moment(cp.data.dateOfBirth).format('MMM DD, YYYY') : 'N/A' }</td>
              <td align="center" id="cp-certification-status">{ getCertifictionStatus(cp.cpCertificationStatus) }</td>
              {(!forms || forms.length === 0) && <td align="center">{ cp.entityFormId }</td>}
              {
                forms && forms.length > 0 && <td align="center" id="cp-cp-form">{(
                  () => {
                    const accountForm = forms.find(({ id }) => id === cp.cpFormId);
                    if (accountForm) {
                      return `${ accountForm.formTypeDescription } (${ accountForm.dateSigned !== null ? moment(accountForm.dateSigned).format('MMM DD, YYYY') : '' })`;
                    }
                    return 'N/A - form not found';
                  }
                )()}
                </td>
              }
              {(!forms || forms.length === 0) && <td align="center">{ cp.cpFormId }</td>}
              <AccessControl allowedPermissions={ [ActivityPerms.accountEdit] }>
                <td align="center" id="cp-actions">
                  { !cp.effectiveTo
                    && <div title={ IsFatcaCrs(cp.entityFormId) ? 'Can not unlink FATCA/CRS-E controlling persons' : 'Unlink controlling person' }><button
                      type="submit"
                      className="btn btn-sm btn-danger"
                      onClick={ () => onConfirmCpUnlink(cp.id, cp.effectiveFrom) }
                      disabled={ !accountIsActive || IsFatcaCrs(cp.entityFormId) }
                    >
                      <span className="icon icon-link" />
                    </button></div>}
                  { cp.effectiveTo
                  && <div title={ IsFatcaCrs(cp.entityFormId) ? 'Can not delete FATCA/CRS-E controlling persons' : 'Remove controlling person' }><button
                    type="submit"
                    className="btn btn-sm btn-danger"
                    onClick={ () => onConfirmCpRemove(cp.id) }
                    disabled={ !accountIsActive || IsFatcaCrs(cp.entityFormId) }
                  >
                    <span className="icon icon-delete" />
                  </button></div>}
                </td>
              </AccessControl>
            </tr>
          ))}
          { (!cpsToDisplay || cpsToDisplay.length === 0)
            && <tr><td colSpan="13" style={ { textAlign: 'center' } } id="cp-no-data-text"><p><b>No Data to Show</b></p></td></tr> }
        </tbody>
      </table>
    </div>
  </div>);
};

AccountControllingPersonsList.propTypes = {
  controllingPersons: PropTypes.arrayOf(PropTypes.shape()),
  isGettingControllingPersons: PropTypes.bool,
  forms: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onConfirmCpUnlink: PropTypes.func.isRequired,
  onConfirmCpRemove: PropTypes.func.isRequired,
  accountIsActive: PropTypes.bool.isRequired
};

AccountControllingPersonsList.defaultProps = {
  controllingPersons: null,
  isGettingControllingPersons: false,
};

export default AccountControllingPersonsList;
